<template>
  <div
    @mouseenter="hover=true; toggled=true"
    @mouseleave="hover=false; toggled=true"
    class="mk-tooltip"
  >
    <transition name="fade">
      <div
        v-if="(shown && !toggled) || hover"
        class="mk-tooltip__tip"
      >
        {{tooltipText}}
      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hover: false,
      toggled: false,
    };
  },
  props: {
    tooltipText: String,
    shown: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-tooltip {
  position: relative;

  &__tip {
    display: flex;
    position: absolute;
    font-size: 14px;
    color: $c_white;
    width: max-content;
    top: -75%;
    left: 75%;
    background-color: $c_warning;
    padding: 5px 15px;
    border-radius: 10px;
    border-bottom-left-radius: 0px;
    z-index: 2;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
